import {useSelector} from "react-redux";
import {loadStripe} from "@stripe/stripe-js";
import getPublicKey from "../../../../utils/get-public-key";
import {Elements,PaymentElement,useElements,useStripe} from "@stripe/react-stripe-js";
import React,{ useState, useEffect }  from "react";
import classes from "./style.module.scss";
import {FormattedMessage} from "react-intl";
import {BigButton} from "../../../../components/button";
import useStyles from "isomorphic-style-loader/useStyles";
import {billingPlaceOrder, getStripeClient} from "../../../../../api";
import {ContainerMask} from "../../../../components/mask";
import {Iconfont} from "../../../../components/icon/iconfont";


const CheckoutForm = props =>{
    useStyles(classes)
    const stripe = useStripe();
    const elements = useElements();
    const [paying, setPaying] = useState(false);
    const {order,payMethod}=props

    const handleSubmit = async (e) => {
        e.preventDefault();
        setPaying(true);
        const { error,paymentIntent  } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                // 支付后重定向客户的返回URL
                return_url: `${window.location.origin}/api/geekopay/success/web?transactionId=${order.transactionId}&payMethod=${payMethod}`, // 成功后跳转地址,
            },
        }).then(result => {
            setPaying(false)
        }).catch(error => {
            setPaying(false)
        });
        setPaying(false);
    };

    return <>
        <PaymentElement options={{
            // 您可以在这里自定义Payment Element
            layout: {
                type: 'accordion',
                defaultCollapsed: false,
                radios: true,
                spacedAccordionItems: false
            }
        }} />
        <BigButton loading={paying} className={classes.CheckoutButton} onClick={handleSubmit}>
            <FormattedMessage id="place_order" defaultMessage="Place Order" />
        </BigButton>
    </>
}

export default props => {
    const [clientSecret, setClientSecret] = useState(null);
    const [order, setOrder] = useState(null);
    const { payMethod,isFastPayment,onError,setShowStripeIdeal } = props
    const global = useSelector(state => state.global)
    const { config } = global
    const promise = loadStripe(getPublicKey(config?.paykeys?.stripe?.publicKey, payMethod))
    useEffect(async () => {
        let order
        const response = await billingPlaceOrder(isFastPayment)
        if (response?.code === 200 && response?.result) {
            order= response?.result
        } else {
            onError({
                message: response?.result || 'Network Error',
                code: response?.code,
                type: (response?.code === 407 || response?.code === 402) ? 'force_refresh' : null
            })
            return null
        }
        if (!order) {
            return
        }
        const data = await getStripeClient({ orderId: order?.id, payMethod:payMethod })
        if(data.code!=200){
            return
        }
        const { clientSecret } = data.result;
        setClientSecret(clientSecret)
        setOrder(order)
    }, []);
    const handleClose = () => {
        setShowStripeIdeal(false)
    }
    return (<React.Fragment>
        <ContainerMask style={{ backgroundColor: 'rgba(0,0,0,0.8)', zIndex: 5 }}>
            {promise&&clientSecret&&order&& <div className={classes.ModalCheckout}>
                <Iconfont onClick={handleClose} className={classes.CloseModal}>&#xe69a;</Iconfont>
                <div className={classes.StripeElements}>
                    <Elements style={{marginTop:'50px'}} stripe={promise} options={{clientSecret}}><CheckoutForm order={order} {...props}/></Elements>
                </div>
            </div>
            }
        </ContainerMask>

        </React.Fragment>)

}